import { useEffect, useState } from "react";
import { useSafeUpdate } from "@awe-web/shared/lib";

export function useInitialize(initialize, dependencies = []) {
  const [isReady, setIsReady] = useState(false);
  const safeSetIsReady = useSafeUpdate(setIsReady);

  useEffect(() => {
    const onCompletion = () => {
      safeSetIsReady(true);
    };

    Promise.resolve(initialize()).then(onCompletion).catch(onCompletion);

    return () => {
      safeSetIsReady(false);
    };
  }, [initialize, safeSetIsReady, ...dependencies]);// eslint-disable-line react-hooks/exhaustive-deps

  return isReady;
}